var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8616",
    "data-name": "\\uADF8\\uB8F9 8616",
    transform: "translate(-641 -1105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7958",
    "data-name": "\\uADF8\\uB8F9 7958",
    transform: "translate(-595 724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_55",
    "data-name": "\\uD0C0\\uC6D0 55",
    transform: "translate(1236 381)",
    fill: "#fff",
    stroke: "#ddd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36941",
    "data-name": "\\uD328\\uC2A4 36941",
    d: "M.52-6.487H1.911a1.354,1.354,0,0,1,1.508-1.43,1.367,1.367,0,0,1,1.5,1.469c0,1.365-1.131,1.625-2.6,1.625H1.885L1.95-2.782H3.237l.052-1.027c1.742,0,3.042-.806,3.042-2.639A2.645,2.645,0,0,0,3.406-9.165,2.626,2.626,0,0,0,.52-6.487ZM3.51-.858a.935.935,0,0,0-.936-.949.938.938,0,0,0-.949.949.938.938,0,0,0,.949.949A.935.935,0,0,0,3.51-.858Z",
    transform: "translate(1243 396)",
    fill: "#222"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d87fc7c292fc563f44e5920f2f614e0a.svg";
export { ForwardRef as ReactComponent };